import React from 'react'
import { Auctions_categories, Tranding_category, CoverflowCarousel, ByCelebrity, NewseLatter, Header } from './components/component';
const DashboardView = () => {
  return (
   <>
   <Header/>
   <CoverflowCarousel/>
   {/* <Tranding_category /> */}
   <Auctions_categories />
   <NewseLatter bgWhite={true} />
   {/* <ByCelebrity/> */}
   </>
  )
}

export default DashboardView